import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModalConfig, ModalInterface } from 'shared/components/modal';
import { FailureGuidanceComponent } from '../failure-guidance/failure-guidance.component';

@Component({
  selector: 'app-failure-guidance-modal',
  standalone: true,
  imports: [FailureGuidanceComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './failure-guidance-modal.component.html',
  host: { class: 'app-failure-guidance-modal' },
})
export class FailureGuidanceModalComponent implements ModalInterface, OnInit {
  public dismiss = null;
  public confirm = null;

  data!: ModalConfig;
  transactionId!: string;

  ngOnInit(): void {
    this.transactionId = this.data?.data?.transactionId;
  }
}
